import { useEffect } from 'react'
import { useAuthStore } from '@/shared/stores/auth'
import { useConnectionStore } from '@/stores/connectionStore'

export function useEngineConnection(
  isLoaded: boolean,
  isSignedIn: boolean | undefined,
  sessionId: string | null | undefined,
): void {
  const tenantId = useAuthStore((state) => state.tenantId)
  const userId = useAuthStore((state) => state.userId)
  useEffect(() => {
    if (!isLoaded || !isSignedIn || !tenantId || !userId) return
    useConnectionStore.getState().initialize(tenantId, userId)
    return () => useConnectionStore.getState().disconnect()
  }, [isLoaded, isSignedIn, sessionId, tenantId, userId])
}
